import { TranslateProvider } from '@pegasus/translation/components';

export default TranslateProvider;
